
import Swal from 'sweetalert2';



export const alert_error = (error) => {
  const responseData = error?.response?.data;
  const responseMessage = responseData?.message;
  const message =
    responseMessage ||
    (typeof responseData === 'string' ? responseData : null) ||
    error?.message ||
    error ||
    'Đã xảy ra lỗi';
  const title = typeof message === 'string' ? message : JSON.stringify(message);

  Swal.mixin({
    toast: true,
    position: 'top-right',
    iconColor: 'white',
    customClass: {
      popup: 'colored-toast'
    },
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  }).fire({
    icon: 'error',
    title: title
  })
};

export const alert_success = (success) => {
  Swal.mixin({
    toast: true,
    position: 'top-right',
    iconColor: 'white',
    customClass: {
      popup: 'colored-toast'
    },
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  }).fire({
    icon: 'success',
    title: success
  })
}

export const copy_native = (value) => {
  alert_success('Đã sao chép');
  window.saochepnative(value);
};
